import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn } from "@angular/router";

import { Constants } from "../../shared/constants/constants";
import { ResourcesApiService } from "../../shared/services";
import { AdaaHelper } from "../utils";

export function PingGuard(): CanActivateFn | CanActivateChildFn {
  return () => {
    const hasSession = AdaaHelper.isDefinedAndNotEmpty(localStorage.getItem(Constants.localStorageKeys.sessionId));

    //Just to ping the server to keep the session alive
    //If session is expired, the logout will be handled by the error interceptor
    if (hasSession) {
      const resourcesApiService = inject(ResourcesApiService);
      resourcesApiService.ping().subscribe();
    }

    return true;
  };
}
